import { has } from 'lodash';
import { Form, Category } from 'ca-api-client';

export default {
    data() {
        return {
            form: null,
            forms: [],
            theme: null,
            themes: [],
            issue: null,
            issues: [],
            submissions: [],
            saving: {
                responseDraft: false, 
            },
            tinymceConfig: {
                disabled: false,
                branding: false,
                height: 350,
                menubar: false,
                toolbar: 'paragraph bold italic underline numlist bullist link',
                api_key: ca.tinymce.api_key,
                lists_indent_on_tab: true,
                plugins: [
                    'autolink lists link anchor',
                    'paste code help wordcount',
                ],
            }, 
        };
    },
    computed: {
        hasForm() {
            return this.form ? true : false;
        },
        hasForms() {
            return this.forms.length > 0;
        },
        hasTheme() {
            return this.theme ? true : false;
        },
        hasThemes() {
            return this.themes.length > 0;
        },
        hasIssues() {
            return this.hasTheme && 
                has(this.theme, 'children') && 
                this.theme.children.data.length > 0;
        },
        hasIssue() {
            return this.issue ? true : false;
        },
    },
    methods: {
        async getForm(id) {
            try {
                this.loading.form = true;
                const form = await Form.$find(id);
                this.$emit('form-loaded', form);
                this.loading.form = false;
                return form;
            } catch (error) {
                this.loading.form = false;
                console.error(error);
                ca.confirm({ type: 'apiError' });
            }
        },
        async getForms() {
            try {
                this.loading.forms = true;
                const forms = await Form
                    .params({
                        filter: {
                            project_id: ca.project.uuid,
                            uses_issues: 1,
                        },
                        limit: -1,
                        sort: 'name',
                    })
                    .$get();

                this.$emit('forms-loaded', forms);
                this.loading.forms = false;
                return forms;
            } catch (error) {
                this.loading.forms = false;
                console.error(error);
                ca.confirm({ type: 'apiError' });
            }
        },
        async getTheme(id) {
            try {
                this.loading.theme = true;
                const theme = await Category.$find(id);
                this.$emit('theme-loaded', theme);
                this.loading.theme = false;
                return theme;
            } catch (error) {
                this.loading.theme = false;
                console.error(error);
                ca.confirm({ type: 'apiError' });
            }
        },
        async getThemes(form) {
            try {
                let formIssue = form.categories ? (form.categories.data.length > 0 ? form.categories.data[0] : null) : null;
                this.loading.themes = true;
                const themes = await Category
                    .params({
                        filter: {
                            client_id: ca.client.uuid,
                            parent_id: formIssue ? formIssue.id : undefined,
                            has_parent: formIssue ? undefined : 0,
                            type: 'engagement',
                        },
                        limit: -1,
                        sort: 'name',
                    })
                    .$get();

                this.$emit('themes-loaded', themes);
                this.loading.themes = false;
                return themes;
            } catch (error) {
                this.loading.themes = false;
                console.error(error);
                ca.confirm({ type: 'apiError' });
            }
        },
        async getIssue(id) { // needes to be called after getTheme
            try {
                this.loading.issue = true;
                const issue = this.theme.children.data.find(issue => issue.id === id);
                this.$emit('issue-loaded', issue);
                this.loading.issue = false;
                return issue;
            } catch (error) {
                this.loading.issue = false;
                console.error(error);
                ca.confirm({ type: 'apiError' });
            }
        },
        async getFormResponses(category_id) {
            try {
                if (!this.hasForm) {
                    throw 'No form selected!';
                }

                this.loading.responses = true;
                const responses = await this.form.responses({category_id});
                this.loading.responses = false;
                return responses;

            } catch (error) {
                this.loading.responses = false;

                if (error.response.status !== 404) {
                    console.error(error);
                    ca.confirm({ type: 'apiError' });
                } else {
                    return {data: {}};
                }
            }
        },
        async saveThemeOverview() {

            this.saving.responseDraft = true;

            try {
                if (!this.hasForm) {
                    throw 'No form selected!';
                } else if (!this.hasTheme) {
                    throw 'No theme selected!';
                }

                await this.form
                    .responses({
                        category_id: this.theme.id,
                        data: { 
                            config: {
                                ...this.responseDraft,
                            },
                        },
                    });

                ca.notify({
                    type: 'success',
                    message: this.$t('sme.respond_theme.save_response_draft_success'),
                    timeout: ca.config('toast.timeout'),
                });

            } catch (error) {
                console.error(error);
                ca.confirm({ type: 'apiError' });
            }

            this.saving.responseDraft = false;
        },
        async saveResponseDraft() {

            this.saving.responseDraft = true;

            try {
                if (!this.hasForm) {
                    throw 'No form selected!';
                } else if (!this.hasTheme) {
                    throw 'No theme selected!';
                } else if (!this.hasIssue) {
                    throw 'No issue selected!';
                }

                await this.form
                    .responses({
                        category_id: this.issue.id,
                        data: { 
                            config: {
                                ...this.responseDraft,
                            },
                        },
                    });

                ca.notify({
                    type: 'success',
                    message: this.$t('sme.respond_theme.save_response_draft_success'),
                    timeout: ca.config('toast.timeout'),
                });

            } catch (error) {
                console.error(error);
                ca.confirm({ type: 'apiError' });
            }

            this.saving.responseDraft = false;
        },
    },
};